import React from 'react';
import ReactPaginate from 'react-paginate';
import Loader from 'react-loader';
import { Client, Tracking } from 'sajari';
import SearchInput from './SearchInput';
import SearchResult from './SearchResult';
import SearchStatus from './SearchStatus';

const getParameterByName = (name) => {
  const match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

const scrollToTop = () => {
  const offset = $('.search-results__container').offset().top - $('.site-header').outerHeight() - 20;

  $('html, body').animate({
    scrollTop: offset,
  }, 'fast');
};

const client = new Client('heartlandbank', 'heartlandbank');
const tracking = new Tracking();
const searchTerm = getParameterByName('q');
const pageSize = 10;

export default class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasResults: false,
      isLoaded: false,
      query: '',
      results: [],
      time: '',
      totalResults: '',
      currentPage: 1,
      totalPages: 0,
    };

    this.queryChanged = this.queryChanged.bind(this);
    this.formSubmission = this.formSubmission.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    if (searchTerm !== null) {
      this.setState({
        query: searchTerm,
      });

      client.searchPipeline(
        'website',
        {
          q: searchTerm,
          resultsPerPage: pageSize,
          page: 1,
        },
        tracking,
        (err, res) => {
          if (!err) {
            this.setState({
              hasResults: true,
              results: res.searchResponse.results,
              time: res.searchResponse.time,
              totalResults: res.searchResponse.totalResults,
              totalPages: Math.floor(res.searchResponse.totalResults / pageSize),
              isLoaded: true,
            });
          } else {
            console.log(err);
          }
        },
      );
    } else {
      this.setState({
        hasResults: false,
      });
    }
  }

  queryChanged(event) {
    this.setState({
      query: event.target.value,
    });
  }

  formSubmission(event) {
    event.preventDefault();

    this.setState({
      isLoaded: false,
    });

    client.searchPipeline(
      'website',
      {
        q: this.state.query,
        resultsPerPage: pageSize,
        page: 1,
      },
      tracking,
      (err, res) => {
        if (!err) {
          this.setState({
            hasResults: true,
            results: res.searchResponse.results,
            time: res.searchResponse.time,
            totalResults: res.searchResponse.totalResults,
            totalPages: Math.floor(res.searchResponse.totalResults / pageSize),
            currentPage: 1,
            isLoaded: true,
          });
        } else {
          console.log(err);
        }
      },
    );
  }

  handlePageChange(page) {
    const newPage = (page.selected + 1);

    this.setState({
      isLoaded: false,
    });

    client.searchPipeline(
      'website',
      {
        q: this.state.query,
        resultsPerPage: pageSize,
        page: newPage,
      },
      tracking,
      (err, res) => {
        if (!err) {
          this.setState({
            hasResults: true,
            results: res.searchResponse.results,
            time: res.searchResponse.time,
            totalResults: res.searchResponse.totalResults,
            totalPages: Math.ceil(res.searchResponse.totalResults / pageSize),
            currentPage: newPage,
            isLoaded: true,
          });

          scrollToTop();
        } else {
          console.log(err);
        }
      },
    );
  }

  render() {
    const results = this.state.results.map((result, i) => {
      return <SearchResult values={result.values} key={i} />;
    });

    const paginationCurrentPage = (this.state.currentPage - 1);

    const resultsSection = (
      <div className="search-results__container">
        <SearchStatus totalResults={this.state.totalResults} time={this.state.time} />
        <Loader loaded={this.state.isLoaded}>
          <div className="search-results__list">
            {results}
          </div>
        </Loader>
        <ReactPaginate
          pageCount={this.state.totalPages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          forcePage={paginationCurrentPage}
          onPageChange={this.handlePageChange}
          previousLabel="Previous"
          nextLabel="Next"
          breakClassName="search-pagination-ellipsis"
          containerClassName="search-pagination"
          pageLinkClassName="search-pagination-btn search-pagination-btn-number"
          activeClassName="active"
          previousLinkClassName="search-pagination-btn search-pagination-btn--back"
          nextLinkClassName="search-pagination-btn search-pagination-btn--next"
        />
      </div>
    );

    return (
      <div>
        <SearchInput query={this.state.query} queryChanged={this.queryChanged} formSubmission={this.formSubmission} />
        {this.state.hasResults ? resultsSection : ''}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/Search.js